import React, { useRef, useState } from 'react'
import {  PrimaryButton, SecondaryButton2th } from '../../components/StyledButtons'
import arrow_down from "../../assets/images/icons/arrow_down_cyan_16px.svg"
import arrow_down_white from "../../assets/images/icons/arrow_down_white_16px.svg"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import ModalPricingCloudPlans from './ModalPricingCloudPlans';
import ModalContactGetTrialForm from '../../components/ModalContactGetTrialForm'

const PricingCloudPlans = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const handleScroll = () => {
        const targetElement = document.getElementById('targetSection');
        if (targetElement) {
            const yOffset = 0;
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const [modalGetTrialOpen, setModalGetTrialOpen] = useState(false);
    const [modalCloudPlansOpen,setModalCloudPlansOpen] = useState(false)

    const modalGetTrialRef = useRef(null);
    const modalCloudPlansRef = useRef(null)

    const handleOverlayClick = (event) => {
        if (modalGetTrialRef.current && !modalGetTrialRef.current.contains(event.target)) {
            setModalGetTrialOpen(false)
        }
        if (modalCloudPlansRef.current && !modalCloudPlansRef.current.contains(event.target)) {
            setModalCloudPlansOpen(false)
        }
    };

    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalGetTrialOpen(false)
            setModalCloudPlansOpen(false)
        }
    };

    return (
        <div className='pricing_cloud-plans container'>
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-xl-3'>
                    <div className='pricing-card'>
                        {language === "en"
                            ?
                            <div>
                                <p className='font-20 font-weight-medium'>Entry plan</p>
                                <p className='pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$50 </span>/Month</p>
                                <ul className='list-unstyled pt-30'>
                                    <li className="checked-line">250 Secure Codes/month</li>
                                    <li className="checked-line">Extra 30¢ per code</li>
                                    <li className="checked-line">Max 10 MB per Code</li>
                                    <li className="checked-line">Unlimited Storage</li>
                                    <li className="checked-line">5 users</li>
                                </ul>
                            </div>
                            :
                            <div>
                                <p className='font-20 font-weight-medium'>Gói ban đầu</p>
                                <p className=' pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$50 </span>/Tháng</p>
                                <ul className='list-unstyled pt-30'>
                                    <li className="checked-line">250 Mã bảo mật/tháng</li>
                                    <li className="checked-line">Thêm 30¢ mỗi mã</li>
                                    <li className="checked-line">Tối đa 10 MB mỗi mã</li>
                                    <li className="checked-line">Lưu trữ không giới hạn</li>
                                    <li className="checked-line">5 người dùng</li>
                                </ul>
                            </div>
                        }

                        <div className='flex justify-center align-center pt-50 flex-column'>
                            <SecondaryButton2th style={{ fontSize: "14px" }}
                            onClick={() => setModalGetTrialOpen(true)}
                            >{t('button.try-standard-for-15-days')}</SecondaryButton2th>
                            <div className='flex'>
                                <p className='see-all-features pt-10 text-primary-cyan' onClick={handleScroll}>{t('button.see-all-features')}</p>
                                <img src={arrow_down} alt="arrow_down_16px" className='mt-10 ml-5' />
                            </div>
                        </div>

                    </div>
                </div>
                <div className='col-sm-12 col-md-6 col-xl-3'>
                    <div className='pricing-card-popular'>
                        <div className='popular-chip'>
                            {language === "en"
                            ?
                            <p>MOST POPULAR</p>
                            :
                            <p>PHỔ BIẾN NHẤT</p>
                            }
                        </div>
                        {language === "en"
                        ?
                        <div>
                            <p className='font-20 font-weight-medium'>Standard Plan</p>
                            <p className='pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$150 </span>/Month</p>
                            <ul className='list-unstyled pt-30'>
                                <li className="checked-line-secondary">900 Secure Codes/month</li>
                                <li className="checked-line-secondary">Extra 20¢ per code</li>
                                <li className="checked-line-secondary">Max 25 MB per Code</li>
                                <li className="checked-line-secondary">Unlimited Storage</li>
                                <li className="checked-line-secondary">10 users</li>
                            </ul>
                        </div>
                        :
                        <div>
                            <p className='font-20 font-weight-medium'>Gói tiêu chuẩn</p>
                            <p className='pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$150 </span>/tháng</p>
                            <ul className='list-unstyled pt-30'>
                                <li className="checked-line-secondary">900 Mã bảo mật/tháng</li>
                                <li className="checked-line-secondary">Thêm 20¢ mỗi mã</li>
                                <li className="checked-line-secondary">Tối đa 25 MB mỗi mã</li>
                                <li className="checked-line-secondary">Lưu trữ không giới hạn</li>
                                <li className="checked-line-secondary">10 người dùng</li>
                            </ul>
                        </div>
                        }

                        <div className='flex justify-center align-center pt-50 flex-column'>
                            <PrimaryButton style={{ fontSize: "14px" }}
                            onClick={() => setModalGetTrialOpen(true)}
                            >{t('button.try-standard-for-15-days')}</PrimaryButton>
                            <div className='flex'>
                                <p className='see-all-features pt-10' onClick={handleScroll}>{t('button.see-all-features')}</p>
                                <img src={arrow_down_white} alt="arrow_down_16px" className='mt-10 ml-5' />
                            </div>
                        </div>

                    </div>
                </div>
                <div className='col-sm-12 col-md-6 col-xl-3'>
                    <div className='pricing-card'>
                        {language === "en"
                        ?
                        <div>
                            <p className='font-20 font-weight-medium'>Business Plan</p>
                            <p className=' pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$450 </span>/Month</p>
                            <ul className='list-unstyled pt-30'>
                                <li className="checked-line">3500 Secure Codes/month</li>
                                <li className="checked-line">Extra 15¢ per code</li>
                                <li className="checked-line">Max 50 MB per Code</li>
                                <li className="checked-line">Unlimited Storage</li>
                                <li className="checked-line">25 users</li>
                                <li className='checked-line'>Sub-accounts</li>
                            </ul>
                        </div>
                        :
                        <div>
                            <p className='font-20 font-weight-medium'>Gói kinh doanh</p>
                            <p className='pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$450 </span>/tháng</p>
                            <ul className='list-unstyled pt-30'>
                                <li className="checked-line">3500 Mã bảo mật/tháng</li>
                                <li className="checked-line">Thêm 15¢ mỗi mã</li>
                                <li className="checked-line">Tối đa 50 MB mỗi mã</li>
                                <li className="checked-line">Lưu trữ không giới hạn</li>
                                <li className="checked-line">25 người dùng</li>
                                <li className='checked-line'>Tài khoản phụ</li>
                            </ul>
                        </div>
                        }

                        <div className='flex justify-center align-center pt-50 flex-column'>
                            <SecondaryButton2th style={{ fontSize: "14px" }}
                            onClick={() => setModalGetTrialOpen(true)}
                            >{t('button.try-standard-for-15-days')}</SecondaryButton2th>
                            <div className='flex'>
                                <p className='see-all-features pt-10 text-primary-cyan' onClick={handleScroll}>{t('button.see-all-features')}</p>
                                <img src={arrow_down} alt="arrow_down_16px" className='mt-10 ml-5' />
                            </div>
                        </div>

                    </div>
                </div>
                <div className='col-sm-12 col-md-6 col-xl-3'>
                    <div className='pricing-card'>
                        {language === "en"
                        ?
                        <div>
                            <p className='font-20 font-weight-medium'>Usage Based</p>
                            <p className='font-32 font-weight-semi-bold pt-10'>Contact Us</p>
                            <ul className='list-unstyled pt-30'>
                                <li className="checked-line">Flexible pricing based on volumes</li>
                            </ul>
                        </div>
                        :
                        <div>
                            <p className='font-20 font-weight-medium'>Theo cách sử dụng</p>
                            <p className='font-32 font-weight-semi-bold pt-10'>Liên hệ chúng tôi</p>
                            <ul className='list-unstyled pt-30'>
                                <li className="checked-line">Giá cả linh hoạt tùy theo số lượng</li>
                            </ul>
                        </div>
                        }
                        <div className='flex justify-center align-center pt-50 flex-column'>
                            <SecondaryButton2th style={{ fontSize: "14px" }}
                            onClick={() => setModalCloudPlansOpen(true)}
                            >{t('button.contact-us')}</SecondaryButton2th>
                            <div className='flex'>
                                <p className='see-all-features pt-10 text-primary-cyan' onClick={handleScroll}>{t('button.see-all-features')}</p>
                                <img src={arrow_down} alt="arrow_down_16px" className='mt-10 ml-5' />
                            </div>
                        </div>
                    </div>
                </div>
                {language === "en" ?
                    <div className='col-sm-12 text-center'>
                        <p className='font-weight-semi-bold text-white'>Start with free trial for Standard and then choose a paid plan</p>
                        <p className='italic text-gray'>All prices are in USD</p>
                    </div>
                    :
                    <div className='col-sm-12 text-center'>
                        <p className='font-weight-semi-bold text-white'>Bắt đầu dùng thử miễn phí Tiêu chuẩn và sau đó chọn gói trả phí</p>
                        <p className='italic text-gray'>Tất cả giá đều tính bằng USD</p>
                    </div>
                }
            </div>
            {modalGetTrialOpen && <ModalContactGetTrialForm
                setOpenModal={setModalGetTrialOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalGetTrialRef} />}
            {modalCloudPlansOpen && <ModalPricingCloudPlans
                setOpenModal={setModalCloudPlansOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalCloudPlansRef} />}
        </div>
    )
}

export default PricingCloudPlans